// packages/web/src/api/users/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { usersList, usersFacets, usersGet } from "../generated/sdk.gen.ts";
import type { UsersListData } from "../generated/types.gen.ts";
import { queryKeys } from "../query-keys.ts";

type UsersListParams = NonNullable<UsersListData["query"]>;

export const usersListOptions = (params: UsersListParams) =>
  queryOptions({
    queryKey: queryKeys.users.list(params),
    queryFn: async () => {
      const { data, error } = await usersList({ query: params });
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });

export const usersFacetsOptions = () =>
  queryOptions({
    queryKey: queryKeys.users.facets(),
    queryFn: async () => {
      const { data, error } = await usersFacets();
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });

export const usersByIdOptions = (id: string) =>
  queryOptions({
    queryKey: queryKeys.users.byId(id),
    queryFn: async () => {
      const { data, error } = await usersGet({ path: { id } });
      if (error) throw error;
      return data;
    },
    enabled: !!id,
    staleTime: 30_000,
  });
